<template>
     <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>基础管理->学校管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="queryForm.name" placeholder="学校名称" style="width: 230px;" ></el-input>  
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-input v-model="queryForm.schoolCode" placeholder="学校码" style="width: 230px;" ></el-input>  
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="info" plain @click="setAssociation">校友会</el-button>
                <el-button type="info" plain @click="setSchool">学校设置</el-button>
                <el-button type="primary" plain @click="setAddSchool" v-if="isAdmin">添加学校</el-button>
            </div>

            <el-table
                :data="depts"
                v-loading="loading"
                :element-loading-text = "loadingText"
                element-loading-background = "rgba(255, 255,255,0.7)"
                row-key="id"
                border
                lazy
                :load="load">
                <el-table-column type="index" :index="indexMethod" label="序号" width="50px"></el-table-column>
                <el-table-column prop="name" label="学校名称"></el-table-column>
                <el-table-column prop="schoolCode" width="100px" label="学校码"></el-table-column>
                <el-table-column label="类型" width="100px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.nature == 1">
                            幼儿园
                        </div>
                        <div v-else-if="scope.row.nature == 2">
                            小学
                        </div>
                        <div v-else-if="scope.row.nature == 3">
                            中学
                        </div>
                        <div v-else-if="scope.row.nature == 0">
                            其他
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="bindDeptNames" label="关联学校" width="200px"></el-table-column>
                <el-table-column prop="deptControllerName" label="学校负责人" width="100px"></el-table-column>
                <el-table-column fixed="right" label="操作" width="273px">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.schoolCode == null"  @click.native.prevent="generatorSchoolCode(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">生成学校码</span>
                        </el-button>
                        <el-button  @click.native.prevent="setSchoolDept(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">设置学校组织</span>
                        </el-button>
                        <el-button  @click.native.prevent="setBindSchool(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">设置关联学校</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <!-- <el-button  @click.native.prevent="delBySchoolId(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">删除</span>
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 设置学校组织弹出框 -->
        <div v-if="setSchoolDeptVisible">
            <setSchoolDept ref="setSchoolDept"></setSchoolDept>
        </div>
        <!-- 设置绑定学校弹出框 -->
        <div v-if="setBindSchoolVisible">
            <setBindSchool ref="setBindSchool"></setBindSchool>
        </div>
        <!-- 修改弹出框 -->
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <!-- 添加学校弹出框 -->
        <div v-if="addSchoolVisible">
            <addSchool ref="addSchool"></addSchool>
        </div>
        <!-- 学校设置弹出框 -->
        <div v-if="setSchoolMainVisible">
            <setSchoolMain ref="setSchoolMain"></setSchoolMain>
        </div>
        <!-- 校友会弹出框 -->
        <div v-if="associationVisible">
            <association ref="association"></association>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import addSchool from './addSchool.vue'; 
    import setSchoolDept from './SetSchoolDept.vue';
    import setBindSchool from './SetBindSchool.vue'; 
    import update from './Update.vue'; 
    import setSchoolMain from './SetSchoolMain.vue'; 
    import association from './association/List.vue';

    export default {
        name:"Dept",
        data(){
            return{
                loading: false,
                loadingText: "",
                setSchoolDeptVisible:false,
                addSchoolVisible:false,
                updateVisible:false,
                setSchoolMainVisible:false,
                associationVisible:false,
                setBindSchoolVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                queryForm:{
                    name: "",
                    schoolCode: ""
                },
                form:{
                    id:""
                },
                depts:[],
                isAdmin: false,
            }
        },
        components: {
            setSchoolDept, setBindSchool, update, addSchool, setSchoolMain, association
        },
        created:function () {
            this.getData()
            // 用户信息
            let userinfo =JSON.parse(sessionStorage.getItem('userinfo'))
            // 如果id为1的话，表示管理员，管理才能设置公共参数
            if(userinfo.id == 1){
                this.isAdmin=true
            }else{
                this.isAdmin=false
            }
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            selectable(row){
                return true
            },
            getData(){
                this.loading=true;
                this.loadingText="数据加载中..."

                let url  = this.deptGetSchoolListUrl
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.queryForm.name,
                    schoolCode: this.queryForm.schoolCode
                };
                this.apiPost(url,data).then((res) => {
                    // console.log(JSON.stringify(res));
                    if(res.status == 200){
                       this.depts = res.data.data
                       this.common.total=res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            // 设置学校组织
            setSchoolDept(data){
                this.setSchoolDeptVisible = true
                this.$nextTick(() => {
                    this.$refs['setSchoolDept'].init(data)
                })
            },
            // 设置关联学校
            setBindSchool(data){
                this.setBindSchoolVisible = true
                this.$nextTick(() => {
                    this.$refs['setBindSchool'].init(data)
                })
            },
            // 生成学校码
            generatorSchoolCode(data){
                this.loading=true;
                this.loadingText="数据生成中..."

                let url  = this.deptGeneratorSchoolCodeUrl
                let reqData = {
                    id: data.id,
                };
                this.apiPost(url,reqData).then((res) => {
                    if(res.status == 200){
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            //新增学校界面
            setAddSchool(){
                this.addSchoolVisible = true
                this.$nextTick(() => {
                    this.$refs['addSchool'].init()
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(data);
                })
            },
            //删除
            delBySchoolId(data){
                this.form.id = data.id
                let msg="删除【"+data.name+"】学校操作，会与该学校相关数据全部清空，是否继续？"
                this.$commonFn.showConfirm2(msg,this.delBySchoolIdSuccess)
            },
            delBySchoolIdSuccess(){
                this.loading=true
                this.loadingText="数据删除中..."

                let url = this.deptRemoveBySchoolIdUrl
                let data = {
                    'schoolId': this.form.id
                };
                // console.log('delBySchoolId',data)
                // return
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1)
                        this.common.page = 1
                        this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                    this.loading=false
                })
            },
            setSchool(){ // 学校设置
                this.setSchoolMainVisible=true
                this.$nextTick(() => {
                    this.$refs['setSchoolMain'].init()
                })
            },
            setAssociation(){ // 校友会
                this.associationVisible=true
                this.$nextTick(() => {
                    this.$refs['association'].init()
                })
            },
            load(tree, treeNode, resolve) {
                console.log('加载数据...')
            },
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>



// WEBPACK FOOTER //
// src/components/page/sys/dept/Dept.vue